import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/store';
import notification from '../notification';
import ROUTES from '../../constants/ROUTES';
import { setUserAuthToken, setUserRefreshToken } from '../../utils/api-helper';
import { wsDisconnect } from '../../utils/wsManager';

const useAuthErrorHandler = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleAuthError = (event) => {
      if (
        event?.detail?.response?.status === 401 &&
        event?.detail?.response?.data?.error === 'Session expired'
      ) {
        if (
          window.location.pathname !== ROUTES.login &&
          window.location.pathname !== ROUTES.sessionExpired
        ) {
          notification('warning', 'Session expired. Please login again.');
        }
        wsDisconnect();
        dispatch(logout());
        window.sessionStorage.setItem('authorization', JSON.stringify({}));
        setUserAuthToken(null);
        setUserRefreshToken(null);
        // navigate(ROUTES.sessionExpired);
        window.location.href = ROUTES.sessionExpired;
      }
    };

    window.addEventListener('authError', handleAuthError);

    return () => {
      window.removeEventListener('authError', handleAuthError);
    };
  }, []);

  return null;
};

export default useAuthErrorHandler;
